<template>
<div class="loader" :style="'height:'+height">
  <div v-if="type=='monitor'">
    <div class="row">
      <div class="col-12 col-md-4 col-lg-6 col-xl-3">
        <div class="loader-text mb-3" style="padding-bottom:35vh"></div>
      </div>
      <div class="col-12 col-md-8 col-lg-6 col-xl-9">
        <div class="loader-text mb-3" style="padding-bottom:35vh"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 col-lg-6 col-xl-3">
        <div class="loader-text mb-3" style="padding-bottom:35vh"></div>
      </div>
      <div class="col-12 col-md-8 col-lg-6 col-xl-9">
        <div class="loader-text mb-3" style="padding-bottom:35vh"></div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-xs-6 col-sm-4 col-md-3"><div class="loader-text pb-5 mb-3"></div></div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3"><div class="loader-square mb-2"></div></div>
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3"><div class="loader-square mb-2"></div></div>
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3"><div class="loader-square mb-2"></div></div>
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3"><div class="loader-square mb-2"></div></div>
    </div>
    <hr>
    <div class="row">
      <div class="col-xs-4 col-sm-3 col-md-2"><div class="loader-text pb-5 mb-3"></div></div>
    </div>
    <div class="row">
      <div class="col-12"><div class="loader-landscape"></div></div>
    </div>
  </div>
  <div v-if="type=='table'">
    <div class="row">
      <div class="col-xs-6 col-sm-4"><div class="loader-text pb-5 mb-2"></div></div>
    </div>
    <div class="row">
      <div class="col-12"><div class="loader-table"></div></div>
    </div>
  </div>
</div>
</template>

<script>
    export default {
      props: ['type', 'icon'],
        data () {
            return {
                height: 0
            }
        },
        mounted() {
           this.height = $('.content-wrapper').innerHeight()+'px';
        }
    }
</script>